import { render } from "./SelectDate.vue?vue&type=template&id=89598a86&ts=true"
import script from "./SelectDate.vue?vue&type=script&lang=ts"
export * from "./SelectDate.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__